import { styled } from 'parkdepot-shared/theme'

export const AppFrameWrapper = styled('div', {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
})

export const BodyWrapper = styled<'main', { $hasNavbar: boolean; $isMobile: boolean }>(
    'main',
    ({ $hasNavbar, $isMobile }) => ({
        height: 'calc(100% - 60px)',
        minHeight: $hasNavbar && $isMobile ? 'calc(100vh - 7.2rem)' : '100vh',
        paddingTop: !$isMobile ? '88px' : '60px',
        flexGrow: 1,
        overflowY: 'visible',
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '480px',
        width: '100%',
        alignSelf: 'center'
    })
)

export const HeaderCommonButtonStylesOverrides = {
    style: {
        fontSize: '16px',
        letterSpacing: '-0.005em',
        padding: '1.9rem 2.4rem'
    }
}

export const HeaderButtonStyleOverrides = {
    style: {
        borderColor: '#000',
        color: '#000',

        [':hover']: {
            backgroundColor: 'transparent',
            opacity: 0.5
        },

        [':active']: {
            backgroundColor: 'transparent'
        },

        [':focus']: {
            backgroundColor: 'transparent'
        }
    }
}
